import { render, staticRenderFns } from "./ResumenMedios.vue?vue&type=template&id=4ec3d720&scoped=true&"
import script from "./ResumenMedios.vue?vue&type=script&lang=js&"
export * from "./ResumenMedios.vue?vue&type=script&lang=js&"
import style0 from "./ResumenMedios.vue?vue&type=style&index=0&id=4ec3d720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3d720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCardText,VIcon,VNavigationDrawer,VSlideXReverseTransition,VSpacer,VToolbar,VToolbarTitle})
